// extracted by mini-css-extract-plugin
export default {"Container":"styles_Container__0rl-o","rotate":"styles_rotate__RI1k9"};